import { Controller } from 'stimulus';

class Score extends Controller {
  // eslint-disable-next-line class-methods-use-this
  onScoreChange({ currentTarget }) {
    const value = parseInt(currentTarget.value, 10);
    const min = parseInt(currentTarget.getAttribute('min'), 10);
    const max = parseInt(currentTarget.getAttribute('max'), 10);
    let newValue = value;

    if (Number.isNaN(value)) return;

    if (value < min) {
      newValue = min;
    }

    if (value > max) {
      newValue = max;
    }

    if (value !== newValue) {
      currentTarget.value = newValue;
    }
  }
}

Score.targets = [];

export default Score;
